var _rect, _rect2, _rect3, _circle, _path, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.578,
    y: 19.578,
    width: 236.845,
    height: 160.845,
    rx: 6.754,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.578,
    y: 19.578,
    width: 236.845,
    height: 160.845,
    rx: 6.754,
    stroke: "#EEE",
    strokeWidth: 3.155
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 98.45,
    y: 36.93,
    width: 63.1,
    height: 17.352,
    rx: 8.676,
    fill: "#EEE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 100.029,
    r: 34.705,
    fill: "#52B2CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.198 94.114h27.606m-27.606 11.831h27.606m-15.775-21.69l-7.887 31.549m19.719-31.55l-7.888 31.55",
    stroke: "#fff",
    strokeWidth: 3.155,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.562,
    y: 145.777,
    width: 190.876,
    height: 17.352,
    rx: 8.676,
    fill: "#EEE"
  })));
}
export default SvgTotals;